import React, { useEffect, useState } from 'react'
import { useParams, withRouter } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../redux/order'
import { Container } from '../../healtheraComponents'
import styled from 'styled-components'
import NewOrder from './NewOrder'
import TabNavbar from '../Shared/TabNavbar'
import PatientData from './PatientData'
import capitalize from '../../utils/capitalize'
import { TablePagination } from '@material-ui/core'
import { ROUTES } from '../Routes/constants'

function OrderPage() {
  const { orderId, pharmacyId } = useParams();
  const dispatch = useDispatch();

  const { order, ordersHistory, pagination } = useSelector(state => state.order);
  const { patient_id } = order || {};

  const [page, setPage] = useState(0);
  const [numberPerPage, setNumberPerPage] = useState(5);
  const [activeTab, setActiveTab] = useState('Active');
  const [tabs, setTabs] = useState({tabs: [{ label: 'Active', active: true }, { label: 'Order history', active: false }]});

  useEffect(() => {
    dispatch(actions.getOrder(orderId))
  }, [dispatch, orderId])

  useEffect(() => {
    if (patient_id) {
      dispatch(actions.getOrdersHistory(patient_id, page, numberPerPage));
    }
  }, [dispatch, patient_id, page, numberPerPage])

  const downloadNominationPDF = async () => {
    const nomination = await dispatch(actions.generateNominationForm(order.pharmacy_id, order.patient_id, order._id, { country: 'uk' }))
    const { payload: { data: { data: { 0: { pdf_url } = {} } } = {} } = {} } = nomination
    if(pdf_url) window.open(pdf_url)
  }

  const renderOrdersList = ordersHistory => {
    return ordersHistory.map(order => renderOrder(order))
  }

  const changeTabHandle = activeTab => {
    setTabs({ tabs: tabs.tabs.map(tabItem => ({ ...tabItem, active: activeTab === tabItem.label })) })
    setActiveTab(activeTab)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setNumberPerPage(+event.target.value);
  }

  const getNextOrderState = processState => {
    switch (processState) {
      case 'new':
        return 'toApprove'
      case 'toApprove':
        return 'toPrepare'
      case 'toPrepare':
        return 'complete'
      default:
        return ''
    }
  }

  const renderOrder = order => {
    const {
      updateRemedyState,
      updateOrderState,
      updateOrderSupportNote,
      patient: { id } = {},
    } = order

    return (
      <NewOrder
        processActionHandler={() =>
          updateOrderState({
            patientId: order.patient_id,
            orderId: order._id,
            processState: getNextOrderState(order.processState),
          })
        }
        cancelActionHandler={() => updateOrderState({ patientId: order.patient_id, orderId: order._id, state: 'cancelled' })}
        toggleMedicationHandler={remedyId => updateRemedyState({ patientId: id, orderId: order.id, remedyId })}
        updateSupportNote={value => updateOrderSupportNote({ patientId: id, orderId: order.id, text: value })}
        key={order._id}
        {...order}
      />
    )
  }

  if (!order)
    return (
      <>
        <TabNavbar
          title="Orders"
          backLink={`${ROUTES.PROBLEMATIC_PHARMACIES}/${pharmacyId}`}
          tabs={[]}
          changeTabHandle={changeTabHandle}
        />
        <NotFound>Order not found.</NotFound>
      </>
    );

  const {
    patient_forename: firstName, patient_surname: lastName,
    patient: { gender, birthday, nhs_number, telephone, username, address, postcode } = {},
    surgery: { surgery_name, address_1, address_2, address_3, address_4, postcode: surgeryPostcode, integration_method } = {},
    delivery: { address: { line1: deliveryLine1, city: deliveryCity, postcode: deliveryPostcode } = {} } = {} } = order

  const details = {
    gender,
    birthDate: birthday ? new Intl.DateTimeFormat('en-UK').format(new Date(birthday * 1000)) : '',
    nhs: nhs_number,
    mobileNumber: telephone,
    email: username
  }

  const patientAddress = {
    line1: address,
    postcode
  }

  const deliveryAddress = {
    line1: deliveryLine1,
    city: deliveryCity,
    postcode: deliveryPostcode
  }

  const nominatedSurgeryAddress = {
    line1: surgery_name,
    line2: address_1,
    line3: address_2,
    line4: address_3,
    line5: address_4,
    postcode: surgeryPostcode,
    integration_method
  }

  return (
    <>
      <Container wrap>
        <TabNavbar
          title={`${firstName} ${lastName}`}
          backLink={`${ROUTES.PROBLEMATIC_PHARMACIES}/${pharmacyId}`}
          tabs={tabs.tabs}
          changeTabHandle={changeTabHandle}
        />
        <Wrapper>
          <PatientData patientData={{ ...details, patientAddress, deliveryAddress, nominatedSurgeryAddress, downloadNominationPDF }} />
          {activeTab === 'Active' && (
            <div>
              {order && order.status && <Section>
                <Header>{`Status: ${capitalize(order.status)}`}</Header>
                {renderOrder(order)}
              </Section>}
            </div>
          )}
          {activeTab === 'Order history' && (
            <>
              <div>
                <Header>Order History</Header>
                {ordersHistory && ordersHistory.length > 0 && <Section>{renderOrdersList(ordersHistory)}</Section>}
                <Pagination
                rowsPerPageOptions={[1,5,10,20]}
                component="div"
                count={pagination.count}
                rowsPerPage={numberPerPage}
                page={page}
                backIconButtonProps={{
                  'aria-label': 'previous page',
                }}
                nextIconButtonProps={{
                  'aria-label': 'next page',
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
              </div>
              
            </>
          )}
        </Wrapper>
      </Container>
    </>
  )
}

export default withRouter(OrderPage)

export const Wrapper = styled.div`
  display: flex;
`

export const Section = styled.div`
  margin-bottom: 50px;
`

export const Header = styled.h1`
  font-size: 24px;
  line-height: 1;
  margin: 19px 0 19px 25px;
`

export const NotFound = styled.p`
  width: 100%;
  margin: 10px;
  font-size: 24px;
  text-align: center;
`

export const Pagination = styled(TablePagination)`
  
`
